import useTrainingUser from './useTrainingUser';

export type { User } from './user';

export default useTrainingUser;
